import React from "react";
import { Button } from "@material-ui/core";

const CustomFileUpload = ({ style, className, fileUrl, fileName, required, ...props }) => {
  return (
    <>
      <div>
        Preview File:&nbsp;
        {fileName &&
          <a href={fileUrl} className="text-success" target="_blank">
            {fileName}
          </a>
        }
      </div>
      <Button
        disabled={props.disabled}
        variant="outlined"
        style={style}
        className={className}
      >
        <input
          {...props}
          {...(fileUrl || !required ? {} : { required }) }
          type="file"
          style={{opacity: 0, position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', cursor: 'pointer'}}
        />
        Select File
      </Button>
    </>
  );
};

export default CustomFileUpload;
